if (!customElements.get('bundle-add-to-cart')) {
  class BundleAddToCart extends HTMLElement {
    constructor() {
      super()

      this.button = this.querySelector('button');
      this.erroMessageField = document.querySelector('bundle-products [data-error-message]');
      this.discountType = this.dataset.discountType;
      this.discountAmount = this.dataset.discountAmount;
      this.includeParentProduct = this.dataset.includeParentProduct;
    }

    connectedCallback() {
      this.attachEvents()

      document.addEventListener('dcb:bundle-is-valid', this.generateItems.bind(this));
    }

    attachEvents() {
      this.button.addEventListener('click', this.onSubmitHandler.bind(this));
    }

    onSubmitHandler(event) {
      event.preventDefault();

      document.dispatchEvent(new CustomEvent('dcb:submit-bundle'));
    }

    generateItems(event) {
      // Prevent multiple calls
      if (this.isGeneratingItems) {
        return;
      }
      this.isGeneratingItems = true;
      
      const bundleId = Date.now();
      // Try multiple selectors to find the quantity input
      const quantityInput = document.querySelector('quantity-input input') || 
                           document.querySelector('.product quantity-input input') ||
                           document.querySelector('input[name="quantity"]') ||
                           document.querySelector('[data-quantity-input]');
      const quantity = Number(quantityInput?.value) || 1;
      
      let items = [];
      let mainProduct = {};
      let mainProductTitle = event.detail.mainProductTitle;
      let mainProductUrl = event.detail.mainProductUrl;

      mainProduct.id = event.detail.mainProductId;
      mainProduct.quantity = quantity;

      mainProduct.properties = {};
      mainProduct.properties._bundleId = bundleId;
      mainProduct.properties._bundleParent = 'true';

      if (this.discountType) {
        mainProduct.properties._bundleDiscountType = this.discountType;
      }

      if (this.discountAmount) {
        mainProduct.properties._bundleDiscountAmount = this.discountAmount;
      }

      // Get variant IDs from checked radio buttons
      const checkedRadios = document.querySelectorAll('bundle-products input[type="radio"]:checked');      
      
      // Create a map to track quantities per variant
      const variantQuantities = new Map();
      
      // Debug: Log all radio button groups
      const allRadios = document.querySelectorAll('bundle-products input[type="radio"]');
      const radioGroups = {};
      allRadios.forEach(radio => {
        if (!radioGroups[radio.name]) {
          radioGroups[radio.name] = [];
        }
        radioGroups[radio.name].push({
          id: radio.id,
          value: radio.value,
          checked: radio.checked
        });
      });
            
      checkedRadios.forEach((radio) => {
        // Track quantity per variant
        const variantId = radio.value;
        const currentQuantity = variantQuantities.get(variantId) || 0;
        variantQuantities.set(variantId, currentQuantity + 1);
      });
           
            
      // Create items from the quantity map
      variantQuantities.forEach((selectionCount, variantId) => {
        let item = {};
        item.properties = {};
        item.id = variantId;
        item.quantity = selectionCount * quantity; // Multiply by user's selected quantity
        item.properties._bundleId = bundleId;
        item.properties._bundleTitle = mainProductTitle;
        item.properties._bundleUrl = mainProductUrl;
        item.properties._bundleItem = 'true';
        if (this.includeParentProduct) {
          item.properties._bundleChild = 'true';
        }
        
        items.push(item);
      });


      if (this.includeParentProduct) {
        items.push(mainProduct);
      }

      if (this.hasAttribute("data-warm-weather-shipping")) {
        const warmWeatherId = this.getAttribute("data-warm-weather-shipping");
        const warmWeatherMode = this.getAttribute("data-warm-weather-mode") || "per_order";
        const warmWeatherQty = warmWeatherMode === "per_triggering_item" ? quantity : 1;
        items.push({
          id: warmWeatherId,
          quantity: warmWeatherQty,
          properties: { _isWarmWeatherShippingProduct: true }
        });
      }

      if (this.hasAttribute('data-coolers') && this.dataset.coolers.trim() != '') {
        const coolers = this.dataset.coolers.trim().split(',');
        const modes = this.dataset.coolerModes ? this.dataset.coolerModes.trim().split(',') : [];
        coolers.forEach((coolerId, index) => {
          const mode = modes[index] || 'per_triggering_item';
          items.push({ id: coolerId, quantity: mode === 'per_order' ? 1 : quantity });
        });
      }

      // Create a deep copy to prevent any reference issues
      const itemsToAdd = JSON.parse(JSON.stringify(items));     

      // Reset the flag after a short delay
      setTimeout(() => {
        this.isGeneratingItems = false;
      }, 100);
      
      this.addToCart(itemsToAdd);
    }

    async addToCart(items) {
      this.button.setAttribute('aria-disabled', true);
      this.button.classList.add('loading');
      this.button.querySelector('span').classList.add('hidden');
      this.button.querySelector('.loading-overlay__spinner').classList.remove(
        'hidden',
      );

      await window.theme
        .addToCart(items)
        .then((result) => {
          if (result.error) {
            this.handleErrorMessage(result.error);
            return;
          }
          this.error = false;
        })
        .finally(() => {
          this.button.classList.remove('loading');
          this.button.querySelector('span').classList.remove('hidden');
          this.button.removeAttribute('aria-disabled');
          this.button.querySelector('.loading-overlay__spinner').classList.add('hidden');

          document.dispatchEvent(new CustomEvent("cart:update"));
        });
    }

    handleErrorMessage(message = '') {
      if (message === '') {
        this.erroMessageField.classList.add('hidden');

        return;
      }

      this.erroMessageField.textContent = message;

      this.erroMessageField.classList.remove('hidden');
    }
  }

  customElements.define('bundle-add-to-cart', BundleAddToCart)
}
